// extracted by mini-css-extract-plugin
export default {"main":"styles_main__6OAET","active":"styles_active__92TJy"};